import { type ReactNode } from 'react';

import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@apps/web/components/ui/tooltip';

export { QUERY_TOOL_NAME } from '@apps/web/components/phoebe_chat_view/tool_calls/tool_name_constants';

export function QueryToolRow({
    label,
    icon,
}: {
    readonly label: string;
    readonly icon: ReactNode;
}) {
    return (
        <Tooltip>
            <TooltipTrigger asChild={true}>
                <div
                    data-testid="query-tool-row"
                    className="text-muted-foreground flex items-start gap-2 text-xs"
                >
                    <span className="mt-0.5 flex-shrink-0">{icon}</span>
                    <span className="line-clamp-2 min-w-0 font-medium">
                        {label}
                    </span>
                </div>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="max-w-72">
                {label}
            </TooltipContent>
        </Tooltip>
    );
}
